import { RESULT_FIRST_SEGMENTS, STATIC_FIRST_SEGMENTS } from './constants';

export const applicationSteps = [
  'start',
  'contact',
  'second',
  'payment',
  'summary',
  'success',
] as const;

export type ApplicationStep = (typeof applicationSteps)[number];

export type RouteKind = 'marketing' | 'application' | 'result';

const staticFirstSegments = new Set<string>(STATIC_FIRST_SEGMENTS);
const resultFirstSegments = new Set<string>(RESULT_FIRST_SEGMENTS);

function getPathSegments(pathname: string) {
  return pathname.split('/').filter(Boolean);
}

export function isApplicationStep(value: string): value is ApplicationStep {
  return applicationSteps.some((step) => step === value);
}

export function getRouteKind(pathname: string): RouteKind {
  const segments = getPathSegments(pathname);

  if (segments.length === 0) {
    return 'marketing';
  }

  const firstSegment = segments[0];

  if (resultFirstSegments.has(firstSegment)) {
    return 'result';
  }

  if (staticFirstSegments.has(firstSegment)) {
    return 'marketing';
  }

  return 'application';
}

export function isMarketingRoute(pathname: string) {
  return getRouteKind(pathname) === 'marketing';
}

export function isApplicationRoute(pathname: string) {
  return getRouteKind(pathname) === 'application';
}

export function getApplicationStep(pathname: string): ApplicationStep | null {
  if (!isApplicationRoute(pathname)) {
    return null;
  }

  const segments = getPathSegments(pathname);

  if (segments.length === 1) {
    return 'start';
  }

  const step = segments[1];

  if (isApplicationStep(step)) {
    return step;
  }

  return null;
}

export function formKeyToStep(formKey: string): ApplicationStep | null {
  switch (formKey) {
    case 'contactFormValid':
      return 'contact';
    case 'secondTenantFormValid':
      return 'second';
    case 'paymentFormValid':
      return 'payment';
    case 'summaryFormValid':
      return 'summary';
    default:
      return null;
  }
}
